'use client'

import { useState } from 'react'
import Image from 'next/image'
import { isPreSizedImage } from '@/lib/feedbridge/helpers'

const Placeholder = () => (
  <div className="absolute inset-0 flex items-center justify-center text-gray-300">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      className="w-12 h-12 opacity-40"
    >
      <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
      <circle cx="9" cy="9" r="2" />
      <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
    </svg>
  </div>
)

interface ListingImageProps {
  src: string | null
  alt: string
}

export function ListingImage({ src, alt }: ListingImageProps) {
  const [error, setError] = useState(false)

  if (!src || error) {
    return <Placeholder />
  }

  return (
    <Image
      src={src}
      alt={alt}
      fill
      quality={60}
      className="object-cover group-hover:scale-105 transition-transform duration-500"
      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
      // Pre-resized CDN variants are already WebP at card size — skip the redundant
      // next/image pass; full-res originals still go through it (Steve 2026-08-23).
      unoptimized={isPreSizedImage(src)}
      onError={() => setError(true)}
    />
  )
}
